import { ServiceContactDelegation } from '../../Model/ServiceContactDelegation/ServiceContactDelegation';

export class GetServiceContactDelegationList {
    constructor(
        records,
        total,
        offset,
        limit,
    ) {
        this.records = records;
        this.total = total;
        this.offset = offset;
        this.limit = limit;
    }
    static createFromResponseData(data) {
    let records = [];

    if (Array.isArray(data)) {
        // Caso 1: es un array directo
        records = data.map((record) => ServiceContactDelegation.createFromResponseData(record));
        return new GetServiceContactDelegationList(records, records.length, 0, records.length);
    }

    if (Array.isArray(data.records)) {
        // Caso 2: es un objeto con propiedad "records"
        records = data.records.map((record) => ServiceContactDelegation.createFromResponseData(record));
        return new GetServiceContactDelegationList(records, data.total, data.offset, data.limit);
    }

    console.warn("⚠️ createFromResponseData: formato de datos desconocido", data);
    return new GetServiceContactDelegationList([], 0, 0, 0);
}
}
